import useApiMutation from 'shared/hooks/use-api-mutation';
import useInfiniteQueryHelpers from 'shared/hooks/use-infinite-query-helpers';
import useQueryHelpers from 'shared/hooks/use-query-helpers';
import {SegmentProps} from '../types';
import segmentsKeys from '../util/segments-keys';

export interface EditSegmentProps extends Omit<SegmentProps, 'id'> {}

const useEditSegment = (id: string) => {
  const {update} = useInfiniteQueryHelpers();
  const {setData} = useQueryHelpers();

  const onSuccess = (data: SegmentProps) => {
    update(segmentsKeys.list(), data);
    setData(segmentsKeys.details(id), data);
  };

  return useApiMutation<EditSegmentProps>({
    url: `/segments/${id}`,
    method: 'PATCH',
    errorTitle: 'Erro ao editar segmento',
    successTitle: 'Editar segmento',
    successMessage: 'Segmento atualizado com sucesso',
    onSuccess,
  });
};

export default useEditSegment;
